// Radha — base/fallback locale locale pack.
// Shell chrome only: nav, header, repeated states and actions. Panel body
// copy is intentionally absent — it is finance/legal terminology that needs
// native review, and t() falls back to English until it is translated.
const en = {
  "nav.overview": "Overview",
  "nav.collections": "Collections",
  "nav.disputes": "Disputes",
  "nav.contracts": "Contracts",
  "nav.invoicing": "Invoicing",
  "nav.recurring": "Recurring",
  "nav.statements": "Statements",
  "nav.creditNotes": "Credit Notes",
  "nav.gst": "GST",
  "nav.tax": "Tax & e-invoicing",
  "nav.reconciliation": "Reconciliation",
  "nav.deductions": "Deductions",
  "nav.withholding": "Withholding",
  "nav.cashflow": "Cashflow",
  "nav.crm": "CRM",
  "nav.forecasts": "Forecasts",
  "nav.reminders": "Reminders",
  "nav.dunning": "Dunning",
  "nav.automation": "Automation",
  "nav.settings": "Settings",
  "nav.privacy": "Privacy",
  "group.receivables": "Receivables",
  "group.planning": "Planning",
  "group.operations": "Operations",
  "group.admin": "Admin",
  "app.tagline": "Revenue Operating System",
  "app.signOut": "Sign out",
  "app.search": "Search",
  "app.toggleTheme": "Toggle colour theme",
  "app.toggleNav": "Toggle navigation",
  "app.language": "Language",
  "app.useTenantDefault": "Use tenant default",
  "state.loading": "Loading…",
  "state.error": "Couldn't load data",
  "state.empty": "Nothing here yet",
  "state.readOnly": "Read-only",
  "action.approve": "Approve",
  "action.reject": "Reject",
  "action.save": "Save",
  "action.saving": "Saving…",
  "action.saved": "Saved",
  "action.cancel": "Cancel",
  "action.export": "Export Excel",
};
export default en;
export type MessageKey = keyof typeof en;
